/**
 *
 * ResourcesSet
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import ResourcesByTypeList from './ResourcesByTypeList';
import AllList from './AllResourcesList';
import AssessmentsList from './AssessmentsList';

function ResourcesSet({ type }) {
  if (type === 'All') return <AllList />;
  if (type === 'Assessments') return <AssessmentsList />;
  const finalType = type === 'Online Programs' ? 'programs' : type;
  const lowerCaseType = finalType.toLowerCase();
  const resourceProps = {
    redirectLink: `resources?types=${type}&presentation=mixed`,
    queryKey: `h-${lowerCaseType}`,
    type: lowerCaseType.slice(0, -1),
    route: `/${lowerCaseType}`,
  };
  return <ResourcesByTypeList {...resourceProps} />;
}

ResourcesSet.propTypes = {
  type: PropTypes.string,
};

export default ResourcesSet;
